var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 42,
    fill: "none",
    viewBox: "0 0 26 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Logo_svg__a)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.754 22.52C19.66 21.492 21 17.782 21 14.296 21 8.665 17.96 5 12.15 5H7.817C5.983 5 5 5.983 5 7.816V33.87A3.138 3.138 0 0 0 8.128 37a3.138 3.138 0 0 0 3.129-3.129c0-4.737-.09-7.597-.313-10.905l2.771 11.576c.402 1.654 1.654 2.413 2.994 2.413 1.654 0 3.308-1.117 3.308-2.994 0-.313-.045-.626-.134-.983-1.61-5.9-2.548-8.894-3.129-10.458m-5.497-3.352v-8.492h.447c1.922 0 3.039 1.743 3.039 4.38 0 2.145-1.117 4.112-3.04 4.112z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Logo_svg__b)",
    d: "M16.754 22.52C19.66 21.492 21 17.782 21 14.296 21 8.665 17.96 5 12.15 5H7.817C5.983 5 5 5.983 5 7.816V33.87A3.138 3.138 0 0 0 8.128 37a3.138 3.138 0 0 0 3.129-3.129c0-4.737-.09-7.597-.313-10.905l2.771 11.576c.402 1.654 1.654 2.413 2.994 2.413 1.654 0 3.308-1.117 3.308-2.994 0-.313-.045-.626-.134-.983-1.61-5.9-2.548-8.894-3.129-10.458m-5.497-3.352v-8.492h.447c1.922 0 3.039 1.743 3.039 4.38 0 2.145-1.117 4.112-3.04 4.112z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_svg__b",
    x1: 53.681,
    x2: 53.681,
    y1: 45.096,
    y2: -1.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "currentColor",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Logo_svg__a",
    width: 25.541,
    height: 41.541,
    x: 0.229,
    y: 0.229,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6614_461",
    stdDeviation: 2.385
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ffabdd54b1d3023d928ccb81bff2593d.svg";
export { ForwardRef as ReactComponent };